<div class="container col-md-12 col-sm-12 bg-white p-5">
    <div class="form-logo">
        <a href="#">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div [innerHTML]="agreement.document_body"></div>
    <div class="ui-g">
        <div class="ui-g-12">
            <label for="esign">eSignature<span class="doctor-form-req">*</span></label>
        </div>
        <div class="ui-g-12">
            <div class="ui-g-12">
                <div class="ui-g">
                    <div class="ui-g-12 ui-lg-4" style="width:60%">
                        <p-radioButton name="signatureOption" value="draw" label="Draw"
                            [(ngModel)]="this.signatureOptionSelected" (click)="changeSignatureOption()"
                            name="signatureOption" #signatureOption="ngModel" required></p-radioButton>
                    </div>
                    <div class="ui-g-12 ui-lg-4" style="width:60%">
                        <p-radioButton name="signatureOption" value="upload" label="Upload"
                            [(ngModel)]="this.signatureOptionSelected" name="signatureOption"
                            (click)="changeSignatureOption()" #signatureOption="ngModel" required></p-radioButton>
                    </div>
                    <div *ngIf="(signatureOption.invalid && (signatureOption.dirty || signatureOption.touched))"
                        class="alert alert-danger">
                        <div *ngIf="signatureOption.errors.required" class="invalid">
                            Choose a Signature Method.
                        </div>
                    </div>
                </div>

                <canvas #canvas name="canvas" *ngIf="this.signatureOptionSelected==='draw'" class="canvass"
                    required></canvas>
                <button type="button" pButton (click)="clearSignatureDraw()"
                    *ngIf="this.signatureOptionSelected==='draw'" style="margin-top: 6px; display:flex;" label="Clear"
                    icon="pi pi-times"></button>

                <button type="button" pButton (click)="addSignature()" *ngIf="this.signatureOptionSelected==='upload'"
                    label="Upload a Signature"></button>
                <!-- </div> -->
            </div>
            <div
                *ngIf="(this.signatureOptionSelected!=null && this.signature_file_name.length>=0 && this.signatureOptionSelected==='upload' && !this.signature_file_type_error)">
                <img [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" />
                {{this.signature_file_name}}
            </div>

        </div>
        <div class="ui-g-12 ui-lg-6 m-auto">
            <div class="form-submit-button my-3">
                <button type="button" (click)="submit()" [disabled]="!has_signed || posting"
                    class="btn btn-primary font-weight-bold text-white p-2">Register</button>
            </div>
        </div>
        <div class="ui-g-12 mt-3 mx-2">
            <div class="text-center">
                <div class="spinner-border text-primary" role="status" *ngIf="this.posting==true">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <!-- <div
                *ngIf="response?.success!=null && response?.success==false && response?.data!=null && response?.data.length>0">
                <p>Following fields are not filled:</p>
                <div *ngFor="let message of response.data ;let i = index" class="alert alert-danger">
                    {{(i+1) +". "+ message}}
                </div>
            </div> -->

            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.response?.error!=null)">
                <div class="alert alert-danger">{{this.response?.error.message}}</div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode!=500)">
                <div class="alert alert-danger" *ngFor="let message of this.serverError?.message">{{message}}
                </div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode==500)">
                <div class="alert alert-danger">{{this.serverError?.message}}</div>
            </div>
            <!-- </div> -->
            <div class="alert alert-danger" *ngIf='response?.error!=null && !response?.error.message'>
                {{response.error}}
            </div>
        </div>
    </div>

    <p-dialog *ngIf="this.signatureDialog" [(visible)]="signatureDialog" [contentStyle]="{height:'750px'}"
        [style]="{width: '80vw'}" (onHide)="close()" header="Upload Signature" [baseZIndex]="10000">
        <div class="ui-g-12 text-gray-underline">
            <b>Note :</b>Supported signature file types are JPEG, JPG and PNG.
        </div>
        <div class="ui-g-12">
            <!-- <label class="button" for="upload">Upload File</label> -->
            <input id='upload' type="file" accept="image/*" (change)="fileChangeEvent($event)" />
        </div>
        <div class="ui-g-12" style="color: red;">
            <ng-container *ngIf="this.signature_file_type_error">
                Not a supported file type.
            </ng-container>
        </div>
        <ng-container *ngIf="!this.signature_file_type_error">
            <div *ngIf="showCropper">
                <div class="ui-g-12 doctor-submit-button-group">
                    <button pButton type="button" class="p-button-info" (click)="rotateLeft()">Rotate left</button>
                    <button pButton type="button" class="p-button-info" (click)="rotateRight()">Rotate
                        right</button>
                    <button pButton type="button" class="p-button-info" (click)="flipHorizontal()">Flip
                        horizontal</button>
                    <button pButton type="button" class="p-button-info" (click)="flipVertical()">Flip
                        vertical</button>
                </div>
                <div class="ui-g-12 doctor-submit-button-group">
                    <button pButton type="button" class="p-button-info" (click)="toggleContainWithinAspectRatio()">
                        {{containWithinAspectRatio?'Fill Aspect Ratio':'Contain Within Aspect Ratio'}}
                    </button>
                    <button pButton type="button" class="p-button-info" (click)="resetImage()">Reset image</button>
                </div>
                <div class="ui-g-12 doctor-submit-button-group">
                    <button pButton type="button" class="p-button-info" (click)="zoomOut()">Zoom -</button>
                    <button pButton type="button" class="p-button-info" (click)="zoomIn()">Zoom +</button>
                </div>
            </div>
            <div class="ui-g-12">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4 / 3" [resizeToWidth]="256"
                    [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                    [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                    [style.display]="showCropper ? null : 'none'"
                    [style.border]="showCropper ? '1px solid black' : 'none'" format="png"
                    (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()">
                </image-cropper>
            </div>
            <div class="ui-g-12">
                <div *ngIf='croppedImage' class="ui-g-12">
                    Preview
                </div>
                <img [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" />
            </div>
        </ng-container>
        <p-footer>
            <button pButton type="button" class="ui-button-success" label="Save" icon="pi pi-save"
                [disabled]="this.showCropper==false || this.croppedImage.length==0" (click)="saveSignature()"></button>
            <button pButton type="button" class="ui-button-warning" label="Cancel" icon="pi pi-times"
                (click)="close()"></button>
        </p-footer>
    </p-dialog>



</div>

<p-dialog [(visible)]="agreement_success" header="Successful" [style]="{'width': '50vw','text-align':'center'}">

    <ng-container>
        <p>This agreement has been signed successfully</p>
    </ng-container>
    <p-footer>
        <button pButton type="button" class="ui-button-success" label="Go to Dashboard" icon="pi pi-home"
            (click)="gotodashboard()"></button>

    </p-footer>
</p-dialog>